// Import Stimulus Controller
import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["alert"];

    connect() {
        if (this.shouldDisplayAlerts()) {
            this.displayAlerts();
            // this.setAlertCookie();
        } else {
            this.hideAllAlerts();
        }
    }

    close(event) {
        const alert = event.target.closest('.flash-alert');
        if (alert) {
            this.hideAlert(alert);
        }
        this.setAlertCookie();
    }

    // Helper Methods

    displayAlerts() {
        this.alertTargets.forEach((alert, index) => {
            const delay = (index + 1) * 2500;
            this.showAlertWithDelay(alert, delay);
            // this.autoHideAlert(alert,  10000);
        });
    }

    showAlertWithDelay(alert, delay) {
        setTimeout(() => {
            alert.classList.add('active');
        }, delay);
    }

    autoHideAlert(alert, delay) {
        setTimeout(() => {
            this.hideAlert(alert);
        }, delay);
    }

    hideAlert(alert) {
        alert.classList.remove('active');
        setTimeout(() => {
            alert.style.display = 'none';
        }, 500);
    }

    hideAllAlerts() {
        this.alertTargets.forEach(alert => {
            alert.style.display = 'none';
        });
    }

    shouldDisplayAlerts() {
        return !this.hasAlertCookie();
    }

    hasAlertCookie() {
        return document.cookie.split('; ').some(row => row.startsWith('BELERTS=true'));
    }

    setAlertCookie() {
        const expires = new Date(Date.now() + 30 * 60 * 1000).toUTCString();
        document.cookie = `BELERTS=true; expires=${expires}; path=/`;
    }
}
